export default function Sitemap() {
  return (
    <div>
      <div className="p-2">
        <a href="/homepage">
          <div className="w-1/2 border-2 border-primary p-1 text-3xl text-red-500">
            Go to Order portal Homepage
          </div>
        </a>
        <a href="/plans">
          <div className="w-1/2 border-2 border-primary p-1 text-3xl text-red-500">
            Go to plan view
          </div>
        </a>
        <a href="/select-number">
          <div className="w-1/2 border-2 border-primary p-1 text-3xl text-red-500">
            Go to select number
          </div>
        </a>
        <a href="/customer-information">
          <div className="w-1/2 border-2 border-primary p-1 text-3xl text-red-500">
            Go to Customer Information
          </div>
        </a>
        <a href="/summary">
          <div className="w-1/2 border-2 border-primary p-1 text-3xl text-red-500">
            Go to Summary
          </div>
        </a>
        <a href="/checkout">
          <div className="w-1/2 border-2 border-primary p-1 text-3xl text-red-500">
            Go to Checkout
          </div>
        </a>
        <a href="/payment">
          <div className="w-1/2 border-2 border-primary p-1 text-3xl text-red-500">
            Go to Payment
          </div>
        </a>
        <a href="/terms-and-conditions">
          <div className="w-1/2 border-2 border-primary p-1 text-3xl text-red-500">
            Go to Terms and Conditions
          </div>
        </a>
      </div>
    </div>
  );
}
